import styled from "styled-components"

import { when } from "utils"

export const ArticleCategory = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  color: ${({ theme, categoryColor }) =>
    theme.component?.highlight || categoryColor || theme.colors.primaryOrange};
`

export const PartnerSponsor = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
`

export const BottomRight = styled.div`
  background: #fff;
  border-radius: 100% 0 0 0;
  padding: 1.5rem 1rem 1rem 1.8rem;
`

export const SignLine = styled.div`
  background: #bbbbbb;
  width: 1.2rem;
  height: 0.2rem;
  margin: 0.2rem 0;

  ${when("short")`
    width: 0.7rem;
  `}
`
